'use client'; // Error components must be Client Components

import { ErrorTryAgain } from '@/components/error';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import styled from 'styled-components';
const ErrorPageWrapper = styled.div`
  padding: 152px 0;
`;

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();
  const onTry = () => {
    router.refresh();
  };
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <ErrorPageWrapper>
      <ErrorTryAgain onEmit={onTry} />
    </ErrorPageWrapper>
  );
}
